<template>
  <div class="main">
    <div class="left">
      <!-- <div>
        项目编号：<el-input style="width: 150px;margin-right:20px" placeholder="请输入项目编号"/>
        <button class="primary-but">查询</button>
      </div> -->
      <div
        v-for="(i, index) in option"
        :key="i.key"
        class="item"
        @click="clickItem(i, index)"
      >
        <div class="line" v-show="i.key === 17 ? false : true"></div>
        <div
          class="circle"
          :style="
            i.disabled === true
              ? 'cursor:no-drop;background:' + i.color
              : 'cursor: pointer;background:' + i.color
          "
        ></div>
        <div
          class="title"
          :style="i.disabled === true ? 'cursor:no-drop' : 'cursor: pointer'"
        >
          <span :style="index === Number(msg - 1) ? 'color: #409eff' : ''">{{
            i.value
          }}</span>
        </div>
      </div>
    </div>
    <div class="right">
      <div v-show="table1">
        <!-- 项目会议-->
        <div class="service">项目会议</div>
        <!-- 项目会议下级联动 -->
        <el-select
          v-model="infoMeetingResult.bpmtableno"
          placeholder="请选择"
          @change="(val) => changeMeetingChoose(val)"
          style="width: 300px; padding-left: 20px"
        >
          <el-option
            v-for="item in meetingChoice"
            :key="item.bpmtableno"
            :label="item.bpmtableno"
            :value="item.bpmtableno"
          >
          </el-option>
        </el-select>
        <div class="table2ZT" style="display: block">
          <span>状态：</span>[
          <span
            v-if="infoMeetingResult.state === '0' ? true : false"
            style="color: #409eff"
            >待客户确认</span
          >
          <span
            v-if="infoMeetingResult.state === '1' ? true : false"
            style="color: #409eff"
            >待客户确认</span
          >
          <span
            v-if="infoMeetingResult.state === '2' ? true : false"
            style="color: #409eff"
            >已确认</span
          >
          <span
            v-if="infoMeetingResult.state === '3' ? true : false"
            style="color: #409eff"
            >投诉</span
          >
          ]
        </div>
        <div class="table2form">
          <div class="tableLeft">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">会议单号</td>
                <td class="bottom_border">
                  {{ infoMeetingResult.bpmtableno }}
                </td>
              </tr>
              <tr>
                <td class="left_title">会议类型</td>
                <td class="bottom_border">
                  {{ infoMeetingResult.meetingtype }}
                </td>
              </tr>
              <tr>
                <td class="left_title">结束日期</td>
                <td class="bottom_border">{{ infoMeetingResult.enddate }}</td>
              </tr>
            </table>
          </div>
          <div class="tableRight">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">会议主题</td>
                <td class="bottom_border">
                  {{ infoMeetingResult.meetingtopical }}
                </td>
              </tr>
              <tr>
                <td class="left_title">开始日期</td>
                <td class="bottom_border">{{ infoMeetingResult.enddate }}</td>
              </tr>
            </table>
          </div>
          <div style="width: 70%">
            <table width="70%" border="1" id="tab1">
              <tr>
                <td class="left_title">
                  发货日期是否变更：<span
                    v-show="infoMeetingResult.ischange === '0' ? true : false"
                    >是</span
                  >
                  <span
                    v-show="infoMeetingResult.ischange === '1' ? true : false"
                    >否</span
                  >
                </td>
                <td class="bottom_border">
                  变更后日期：<span>{{ infoMeetingResult.changedate }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="bottomThird">
          <div>
            <div class="conte" style="padding-left: 20px">参会人员</div>
            <div
              class="divcss1"
              v-for="(
                item, index
              ) in infoMeetingResult.saleMeetingPeoplesEntityList"
              :key="index"
            >
              <table id="tab1" border="1">
                <tr>
                  <td class="left_title">姓名</td>
                  <td class="bottom_border">{{ item.personname }}</td>
                </tr>
                <tr>
                  <td class="left_title">电话</td>
                  <td class="bottom_border">{{ item.persontel }}</td>
                </tr>
                <tr>
                  <td class="left_title">单位</td>
                  <td class="bottom_border">{{ item.companycode }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-show="table2">
        <div v-show="isAdd">
          <div class="service">内容详情</div>
          <!-- fat下级联动 -->
          <el-select
            v-model="fatResult.testlistno"
            placeholder="请选择"
            @change="(val) => changeFatChoose(val)"
            style="width: 300px; padding-left: 20px"
          >
            <el-option
              v-for="item in fatChoice"
              :key="item.testlistno"
              :label="item.testlistno"
              :value="item.testlistno"
            >
            </el-option>
          </el-select>
          <div class="table2ZT" style="display: block">
            <span>状态：</span>[
            <span v-if="fatState === '' ? true : false" style="color: #409eff"
              >待客户确认</span
            >
            <span v-if="fatState === '1' ? true : false" style="color: #409eff"
              >已确认</span
            >
            <span v-if="fatState === '0' ? true : false" style="color: #409eff"
              >变更退回</span
            >
            ]
          </div>
          <div class="pref">流程菜单</div>
          <div style="padding-left: 20px; padding-right: 20px">
            <table width="100%" border="1" id="tab1">
              <tr>
                <td class="left_title">项目名称</td>
                <td class="bottom_border">{{ fatResult.projname }}</td>
              </tr>
              <tr>
                <td class="left_title">项目实施地</td>
                <td class="bottom_border">{{ fatResult.projlocal }}</td>
              </tr>
            </table>
          </div>
          <div class="pref" v-show="allshow">测试基本信息</div>
          <div style="padding-left: 20px; padding-right: 20px" v-show="allshow">
            <table width="100%" border="1" id="tab1">
              <tr>
                <td class="left_title">计划发货日期</td>
                <td class="bottom_border">{{ fatResult.trandate }}</td>
              </tr>
              <tr>
                <td class="left_title">FAT物资就位日期</td>
                <td class="bottom_border">{{ fatResult.fatdate }}</td>
              </tr>
              <tr>
                <td class="left_title">外配柜数量</td>
                <td class="bottom_border">{{ fatResult.extracabinetno }}</td>
              </tr>
              <tr>
                <td class="left_title">系统柜数量</td>
                <td class="bottom_border">{{ fatResult.syscabinetno }}</td>
              </tr>
              <tr>
                <td class="left_title">测试内容</td>
                <td class="bottom_border">{{ fatResult.testcontent }}</td>
              </tr>
              <tr>
                <td class="left_title">测试开始时间</td>
                <td class="bottom_border">{{ fatResult.fatstarttime }}</td>
              </tr>
              <tr>
                <td class="left_title">测试结束时间</td>
                <td class="bottom_border">{{ fatResult.fatendtime }}</td>
              </tr>
            </table>
          </div>
          <div>
            <button
              class="primary-but"
              style="margin-left: 20px; width: 120px"
              @click="rdmsHandle"
            >
              RDMS(远程管家)
            </button>
          </div>
          <div
            v-if="
              fatResult.saleFatLocationEntityList instanceof Array &&
              fatResult.saleFatLocationEntityList.length
            "
          >
            <!-- <div v-if="fatResult.saleFatLocationEntityList?fatResult.saleFatLocationEntityList.length === 0 ? false : true"> -->
            <div class="pref">来杭人员</div>
            <div class="divcss">
              <div
                class="divcss1"
                v-for="(op, index) in fatResult.saleFatLocationEntityList"
                :key="index"
              >
                <table id="tab1" border="1">
                  <tr>
                    <td class="left_title">姓名</td>
                    <td class="bottom_border">{{ op.fatlocationperson }}</td>
                  </tr>
                  <tr>
                    <td class="left_title">电话</td>
                    <td class="bottom_border">{{ op.fatlocationtele }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div
            v-if="
              fatResult.saleFatDevicesEntityList instanceof Array &&
              fatResult.saleFatDevicesEntityList.length
            "
          >
            <!-- <div> -->
            <div class="pref">测试范围</div>
            <div class="divcss">
              <div
                class="divcss1"
                v-for="(d, index) in fatResult.saleFatDevicesEntityList"
                :key="index"
              >
                <table id="tab1" border="1">
                  <tr>
                    <td class="left_title">装置名称</td>
                    <td class="bottom_border">{{ d.devicename }}</td>
                  </tr>
                  <tr>
                    <td class="left_title">负责人</td>
                    <td class="bottom_border">{{ d.chargername }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <!-- <div v-if=" fatResult.saleFatResultEntityList instanceof Array && fatResult.saleFatResultEntityList.length"> -->
          <div
            v-if="
              fatResult.saleFatResultEntityList
                ? fatResult.saleFatResultEntityList.length
                : false
            "
          >
            <!-- <div> -->
            <div class="pref">测试结果</div>
            <div class="divcss">
              <div
                class="divcss1"
                v-for="(opj, index) in fatResult.saleFatResultEntityList"
                :key="index"
              >
                <table id="tab1" border="1">
                  <tr>
                    <td class="left_title">FAT单据号</td>
                    <td class="bottom_border">{{ opj.fatnumber }}</td>
                  </tr>
                  <tr>
                    <td class="left_title">问题描述</td>
                    <td class="bottom_border">{{ opj.fattestproblem }}</td>
                  </tr>
                  <tr>
                    <td class="left_title">测试开始时间</td>
                    <td class="bottom_border">{{ opj.actstartdate }}</td>
                  </tr>
                  <tr>
                    <td class="left_title">测试结束时间</td>
                    <td class="bottom_border">{{ opj.actenddate }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div
            v-if="
              fatResult.bgstarttime.length && fatResult.bgendtime.length === 0
                ? false
                : true
            "
          >
            <div class="pref">变更信息</div>
            <div style="padding-left: 20px; padding-right: 20px">
              <table width="100%" border="1" id="tab1">
                <tr>
                  <td class="left_title">开始变更日期</td>
                  <td class="bottom_border">{{ fatResult.bgstarttime }}</td>
                </tr>
                <tr>
                  <td class="left_title">结束变更日期</td>
                  <td class="bottom_border">{{ fatResult.bgendtime }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div style="text-align: center" v-show="isAgree">
            <button class="primary-but" @click="agree">确认</button>
            <button class="info-but" @click="disAgre">变更</button>
          </div>
        </div>
        <div v-show="!isAdd">
          <div class="service">退回原因</div>
          <div class="table2form">
            <el-form
              ref="form"
              :model="fatResult"
              label-width="150px"
              style="width: 60%; padding: 25px 0"
            >
              <el-form-item label="出厂测试单据号">
                <el-input
                  v-model="fatResult.testlistno"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="FAT单据号">
                <el-input
                  v-model="fatResult.fatnumber"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="测试开始时间" v-show="fillAdd">
                <el-col>
                  <el-input
                    v-model="fatResult.fatstarttime"
                    :disabled="true"
                  ></el-input>
                  <!-- <el-date-picker type="date"   value-format="yyyy-MM-dd hh:mm:ss"  v-model="fatResult.fatstarttime" style="width: 100%;" :readonly="!noAgree"></el-date-picker> -->
                </el-col>
              </el-form-item>
              <el-form-item label="测试结束时间" v-show="fillAdd">
                <el-col>
                  <el-input
                    v-model="fatResult.fatendtime"
                    :disabled="true"
                  ></el-input>
                  <!-- <el-date-picker type="date"  value-format="yyyy-MM-dd hh:mm:ss" v-model="fatResult.fatendtime" style="width: 100%;" :readonly="!noAgree"></el-date-picker> -->
                </el-col>
              </el-form-item>
              <el-form-item label="变更开始时间" v-show="fillover">
                <el-col>
                  <el-date-picker
                    type="datetime"
                    placeholder="选择变更开始时间"
                    value-format="yyyy-MM-dd hh:mm:ss"
                    v-model="fatResult.bgstarttime"
                    style="width: 100%"
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="变更结束时间" v-show="fillover">
                <el-col>
                  <el-date-picker
                    type="datetime"
                    placeholder="选择变更结束时间"
                    value-format="yyyy-MM-dd hh:mm:ss"
                    v-model="fatResult.bgendtime"
                    style="width: 100%"
                  ></el-date-picker>
                </el-col>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <div class="new" style="padding-left: 20px" v-show="cotDisagree">
              <!-- <button class="add-but"  @click="add">+</button> -->
              <button class="add-but" @click="add">选择来杭人员+</button>
            </div>
            <div
              v-for="(item, index) in fatResult.saleFatLocationEntityList"
              :key="index"
              class="addPerson"
            >
              <!-- <div>{{item.fatlocationperson}}</div> -->
              <div class="person-info">
                {{ item.fatlocationperson }}
                <span
                  class="person-del"
                  @click="handleDel(index)"
                  v-show="cotDisagree"
                  >X</span
                >
              </div>
            </div>
          </div>
          <div style="text-align: center">
            <button class="primary-but" @click="reback">返回</button>
            <button class="info-but" v-show="fillAdd" @click="fillIn">
              保存
            </button>
            <button class="info-but" v-show="fillover" @click="fillTime">
              保存
            </button>
          </div>
        </div>
      </div>
      <!--系统发运清单-->
      <div v-show="table3">
        <div class="service">系统发运清单</div>
        <el-select
          v-model="changeInfo"
          placeholder="请选择"
          @change="(val) => changeChoose(val)"
          style="padding-left: 20px"
        >
          <el-option
            v-for="item in choose"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="table2ZT" style="display: block">
          <span>状态：</span>[
          <span
            v-if="infoParcelResult.state === '1' ? true : false"
            style="color: #409eff"
            >生效</span
          >
          <span
            v-if="infoParcelResult.state === '0' ? true : false"
            style="color: #409eff"
            >未生效</span
          >
          <span
            v-if="infoParcelResult.state === '2' ? true : false"
            style="color: #409eff"
            >已处理</span
          >
          <span
            v-if="infoParcelResult.state === '3' ? true : false"
            style="color: #409eff"
            >投诉</span
          >
          ]
        </div>
        <div class="table2form">
          <div style="width: 48%">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">项目名称</td>
                <td class="bottom_border">{{ infoParcelResult.projname }}</td>
              </tr>
              <tr>
                <td class="left_title">合同编号</td>
                <td class="bottom_border">{{ infoParcelResult.contractno }}</td>
              </tr>
            </table>
          </div>
          <div class="tableLeft">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">收货人</td>
                <td class="bottom_border">
                  {{ infoParcelResult.topersonname }}
                </td>
              </tr>
              <tr>
                <td class="left_title">收货单位</td>
                <td class="bottom_border">{{ infoParcelResult.tocompany }}</td>
              </tr>
            </table>
          </div>
          <div class="tableRight">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">收货电话</td>
                <td class="bottom_border">
                  {{ infoParcelResult.topersontele }}
                </td>
              </tr>
              <tr>
                <td class="left_title">收货地址</td>
                <td class="bottom_border">{{ infoParcelResult.toaddress }}</td>
              </tr>
            </table>
          </div>
          <div class="tableLeft">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">中控货运专员电话</td>
                <td class="bottom_border">
                  {{ infoParcelResult.supconlogisticspersontele }}
                </td>
              </tr>
              <tr>
                <td class="left_title">中控协调联系人电话</td>
                <td class="bottom_border">
                  {{ infoParcelResult.supconcoordinatepersontele }}
                </td>
              </tr>
            </table>
          </div>
          <div class="tableRight">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">中控协调联系人</td>
                <td class="bottom_border">
                  {{ infoParcelResult.supconcoordinatepersonname }}
                </td>
              </tr>
            </table>
          </div>
          <div class="tableLeft">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">启动单号时间</td>
                <td class="bottom_border">
                  {{ infoParcelResult.transporttime }}
                </td>
              </tr>
              <tr>
                <td class="left_title">快递公司</td>
                <td class="bottom_border">
                  {{ infoParcelResult.shipmentcompany }}
                </td>
              </tr>
            </table>
          </div>
          <div class="tableRight">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">货运方式</td>
                <td class="bottom_border">
                  {{ infoParcelResult.shipmenttype }}
                </td>
              </tr>
              <tr>
                <td class="left_title">承运方式</td>
                <td class="bottom_border">
                  {{ infoParcelResult.expresscompany }}
                </td>
              </tr>
            </table>
          </div>
          <div class="tableLeft">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">大木箱</td>
                <td class="bottom_border">
                  {{ infoParcelResult.woodencasel }}
                </td>
              </tr>
              <tr>
                <td class="left_title">电缆</td>
                <td class="bottom_border">{{ infoParcelResult.cable }}</td>
              </tr>
              <tr>
                <td class="left_title">中木箱</td>
                <td class="bottom_border">
                  {{ infoParcelResult.woodencasem }}
                </td>
              </tr>
            </table>
          </div>
          <div class="tableRight">
            <table border="1" id="tab1">
              <tr>
                <td class="left_title">总箱数</td>
                <td class="bottom_border">
                  {{ infoParcelResult.totalcasenum }}
                </td>
              </tr>
              <tr>
                <td class="left_title">其他</td>
                <td class="bottom_border">{{ infoParcelResult.other }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="bottomThird" style="padding-bottom: 20px">
          <div style="padding-left: 20px; padding-right: 20px">
            <div class="conte">主要发货部件</div>
            <el-input
              type="textarea"
              v-model="infoParcelResult.mainpart"
              :rows="5"
              :disabled="true"
            ></el-input>
          </div>
        </div>
      </div>
      <div v-show="table4">
        <!--工程服务记录-->
        <div class="service">工程服务记录</div>
        <!-- 工程服务下级联动 -->
        <el-select
          v-model="infoServiceResult.bpmTableNo"
          placeholder="请选择"
          @change="(val) => changeServiceChoose(val)"
          style="width: 300px; padding-left: 20px"
        >
          <el-option
            v-for="item in serviceChoice"
            :key="item.bpmTableNo"
            :label="item.bpmTableNo"
            :value="item.bpmTableNo"
          >
          </el-option>
        </el-select>
        <div class="table2ZT" style="display: block">
          <span>状态：</span>[
          <span
            v-if="infoServiceResult.state === '1' ? true : false"
            style="color: #409eff"
            >待客户确认</span
          >
          <span
            v-if="infoServiceResult.state === '2' ? true : false"
            style="color: #409eff"
            >已确认</span
          >
          <span
            v-if="infoServiceResult.state === '3' ? true : false"
            style="color: #409eff"
            >已投诉</span
          >
          <span
            v-if="infoServiceResult.state === '4' ? true : false"
            style="color: #409eff"
            >已制单</span
          >
          ]
        </div>
        <div>
          <div class="table2form">
            <div class="tableLeft">
              <table border="1" id="tab1">
                <tr>
                  <td class="left_title">服务单号</td>
                  <td class="bottom_border">
                    {{ infoServiceResult.bpmTableNo }}
                  </td>
                </tr>
                <tr>
                  <td class="left_title">项目编码</td>
                  <td class="bottom_border">
                    {{ infoServiceResult.projectNo }}
                  </td>
                </tr>
                <tr>
                  <td class="left_title">客户编码</td>
                  <td class="bottom_border">
                    {{ infoServiceResult.customerNo }}
                  </td>
                </tr>
                <tr>
                  <td class="left_title">联系人姓名</td>
                  <td class="bottom_border">
                    {{ infoServiceResult.personName }}
                  </td>
                </tr>
              </table>
            </div>
            <div class="tableRight">
              <table border="1" id="tab1">
                <tr>
                  <td class="left_title">合同编号</td>
                  <td class="bottom_border">
                    {{ infoServiceResult.contractNo }}
                  </td>
                </tr>
                <tr>
                  <td class="left_title">项目名称</td>
                  <td class="bottom_border">
                    {{ infoServiceResult.projectName }}
                  </td>
                </tr>
                <tr>
                  <td class="left_title">客户名称</td>
                  <td class="bottom_border">
                    {{ infoServiceResult.customerName }}
                  </td>
                </tr>
                <tr>
                  <td class="left_title">联系人电话</td>
                  <td class="bottom_border">
                    {{ infoServiceResult.personTel }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="bottomThird" v-if="infoServiceResult.inRdms === '1'">
            <div style="padding-right: 20px; padding-bottom: 10px">
              <div class="conte">RDMS信息</div>
              <div class="table2form">
                <div class="tableLeft">
                  <table border="1" id="tab1">
                    <tr>
                      <td class="left_title">开始时间</td>
                      <td class="bottom_border">
                        {{ infoServiceResult.rdmsStartTime }}
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="tableRight">
                  <table border="1" id="tab1">
                    <tr>
                      <td class="left_title">结束时间</td>
                      <td class="bottom_border">
                        {{ infoServiceResult.rdmsEndTime }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <button
                class="primary-but"
                style="margin-left: 20px; width: 120px"
                @click="rdmsHandle"
                v-if="personTel === userNameInfo"
              >
                RDMS(远程管家)
              </button>
            </div>
          </div>
        </div>
        <div class="bottomThird" v-if="infoServiceResult.inMeeting === '1'">
          <div style="padding-right: 20px; padding-bottom: 10px">
            <div class="conte">视频会议</div>
            <div class="table2form">
              <div class="tableLeft">
                <table border="1" id="tab1">
                  <tr>
                    <td class="left_title">开始时间</td>
                    <td class="bottom_border">
                      {{ infoServiceResult.meetingstartTime }}
                    </td>
                  </tr>
                  <tr>
                    <td class="left_title">结束时间</td>
                    <td class="bottom_border">
                      {{ infoServiceResult.meetingendTime }}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="tableRight">
                <table border="1" id="tab1">
                  <tr>
                    <td class="left_title">会议室ID</td>
                    <td class="bottom_border">
                      {{ infoServiceResult.meetingId }}
                    </td>
                  </tr>
                  <tr>
                    <td class="left_title">会议室密码</td>
                    <td class="bottom_border">
                      {{ infoServiceResult.password }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="bottomThird" v-if="infoServiceResult.state !== '4'">
          <div style="padding-right: 20px; padding-bottom: 10px">
            <div class="conte">服务信息</div>
            <div class="table2form">
              <div class="tableLeft">
                <table border="1" id="tab1">
                  <tr>
                    <td class="left_title">本次服务时长</td>
                    <td class="bottom_border">
                      {{ infoServiceResult.serviceTimes }}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="tableRight">
                <table border="1" id="tab1">
                  <tr>
                    <td class="left_title">累计服务时长</td>
                    <td class="bottom_border">
                      {{ infoServiceResult.totalServiceTimes }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="bottomThird" v-if="infoServiceResult.state !== '4'">
          <div style="">
            <div class="conte">本次推进节点</div>
            <el-table
              :data="infoServiceResult.pushNodeList"
              style="width: 100%"
            >
              <el-table-column
                label="装置名称"
                prop="deviceName"
                align="center"
              ></el-table-column>
              <el-table-column
                label="自动化产品型号"
                prop="deviceProvider"
                align="center"
              ></el-table-column>
              <el-table-column
                label="项目节点"
                prop="projectNode"
                align="center"
              ></el-table-column>
              <el-table-column
                label="项目进度"
                prop="newPercent"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="bottomThird" v-if="infoServiceResult.state !== '4'">
          <div style="">
            <div class="conte">本次服务人员信息</div>
            <el-table :data="infoServiceResult.personList" style="width: 100%">
              <el-table-column
                label="人员编码"
                prop="servicePersonCode"
                align="center"
              ></el-table-column>
              <el-table-column
                label="服务人员"
                prop="servicePerson"
                align="center"
              ></el-table-column>
              <el-table-column
                label="出发日期"
                prop="startDate"
                align="center"
              ></el-table-column>
              <el-table-column
                label="离开日期"
                prop="endDate"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="bottomThird" v-if="infoServiceResult.state !== '4'">
          <div style="">
            <div class="conte">本次服务内容</div>
            <el-table :data="infoServiceResult.recordsList" style="width: 100%">
              <el-table-column
                label="服务日期"
                prop="serviceDate"
                align="center"
              ></el-table-column>
              <el-table-column
                label="服务人员"
                prop="servicePerson"
                align="center"
              ></el-table-column>
              <el-table-column
                label="装置名称"
                prop="deviceName"
                align="center"
              ></el-table-column>
              <el-table-column
                label="自动化产品型号"
                prop="deviceProvider"
                align="center"
              ></el-table-column>
              <el-table-column
                label="工作类别"
                prop="workType"
                align="center"
              ></el-table-column>
              <el-table-column
                label="工作内容"
                prop="workContent"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 80%; margin: auto">
      <div
        class="card"
        style="margin-top: 20px; border-top: 1px solid #eee"
        v-if="attachmentShow"
      >
        <div class="cardTitle">附件</div>
        <div class="cardSubtitle">
          附件数量：{{
            relatedDocuments[complaintIndex]
              ? relatedDocuments[complaintIndex].length
              : 0
          }}
        </div>
      </div>
      <ul class="doclist" v-if="attachmentShow">
        <li
          @click.stop="download(item2)"
          v-for="(item2, index2) in relatedDocuments[complaintIndex]"
          :key="index2"
        >
          <img
            v-if="
              item2.filename.slice(item2.filename.indexOf('.') + 1) === 'xls'
            "
            src="static/img/excel.png"
          />
          <img
            v-else-if="
              item2.filename.slice(item2.filename.indexOf('.') + 1) === 'xlsx'
            "
            src="static/img/excel.png"
          />
          <img
            v-else-if="
              item2.filename.slice(item2.filename.indexOf('.') + 1) === 'doc'
            "
            src="static/img/word.png"
          />
          <img
            v-else-if="
              item2.filename.slice(item2.filename.indexOf('.') + 1) === 'docx'
            "
            src="static/img/word.png"
          />
          <img
            v-else-if="
              item2.filename.slice(item2.filename.indexOf('.') + 1) === 'pdf'
            "
            src="static/img/ppf.png"
          />
          <img
            v-else-if="
              item2.filename.slice(item2.filename.indexOf('.') + 1) === 'ppt'
            "
            src="static/img/ppt.png"
          />
          <img
            v-else-if="
              item2.filename.slice(item2.filename.indexOf('.') + 1) === 'pptx'
            "
            src="static/img/ppt.png"
          />
          <img v-else src="static/img/占位图.png" />
          <p>{{ item2.filevideoname }}</p>
        </li>
      </ul>
      <div v-if="!this.table2">
        <div class="card" v-if="fatComplaint && complaintShow">
          <div class="cardTitle" style="padding-top: 10px">
            投诉意见
            <el-button
              size="mini"
              type="text"
              style="padding-left: 20px"
              @click="handleShowComplaint()"
              >附件上传</el-button
            >
          </div>

          <!-- <div class="cardSubtitle">附件数量：{{relatedDocuments[complaintIndex] ? relatedDocuments[complaintIndex].length : 0}}</div> -->
        </div>
        <el-input
          v-if="fatComplaint"
          style="padding: 20px"
          type="textarea"
          :rows="5"
          v-model="complaint[complaintIndex]"
        ></el-input>
        <el-table
          :data="suggestion"
          style="width: 100%; margin-top: 20px"
          height="250"
          border
          v-if="suggestionShow && this.table4"
        >
          <el-table-column
            label="处理人"
            prop="userName"
            width="120px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="处理状态"
            prop="stateName"
            min-width="80px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="处理时间"
            prop="createDate"
            width="160px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="投诉意见"
            prop="opinion"
            align="center"
          ></el-table-column>
        </el-table>
        <el-table
          :data="suggestion"
          style="width: 100%; margin-top: 20px"
          height="250"
          border
          v-else
        >
          <el-table-column
            label="处理人"
            prop="username"
            width="120px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="处理状态"
            prop="stateName"
            min-width="80px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="处理时间"
            prop="createdate"
            width="160px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="投诉意见"
            prop="opinion"
            align="center"
          ></el-table-column>
        </el-table>
        <div class="card" v-if="complaintFileShow">
          <div class="cardTitle">投诉附件</div>
          <div class="cardSubtitle">
            附件数量：{{
              comeFileList[complaintIndex]
                ? comeFileList[complaintIndex].length
                : 0
            }}
          </div>
        </div>
        <ul class="doclist" v-if="complaintFileShow">
          <li
            v-for="(item2, index2) in comeFileList[complaintIndex]"
            :key="index2"
          >
            <div style="display: inline-flex">
              <div @click.stop="download(item2)">
                <img
                  v-if="
                    item2.filename.slice(item2.filename.indexOf('.') + 1) ===
                    'xls'
                  "
                  src="static/img/excel.png"
                />
                <img
                  v-else-if="
                    item2.filename.slice(item2.filename.indexOf('.') + 1) ===
                    'xlsx'
                  "
                  src="static/img/excel.png"
                />
                <img
                  v-else-if="
                    item2.filename.slice(item2.filename.indexOf('.') + 1) ===
                    'doc'
                  "
                  src="static/img/word.png"
                />
                <img
                  v-else-if="
                    item2.filename.slice(item2.filename.indexOf('.') + 1) ===
                    'docx'
                  "
                  src="static/img/word.png"
                />
                <img
                  v-else-if="
                    item2.filename.slice(item2.filename.indexOf('.') + 1) ===
                    'pdf'
                  "
                  src="static/img/ppf.png"
                />
                <img
                  v-else-if="
                    item2.filename.slice(item2.filename.indexOf('.') + 1) ===
                    'ppt'
                  "
                  src="static/img/ppt.png"
                />
                <img
                  v-else-if="
                    item2.filename.slice(item2.filename.indexOf('.') + 1) ===
                    'pptx'
                  "
                  src="static/img/ppt.png"
                />
                <img v-else src="static/img/占位图.png" />
                <p>{{ item2.filevideoname }}</p>
              </div>
              <div
                class="dekk"
                v-show="item2.delId"
                @click="delFiles(item2, index2)"
              >
                x
              </div>
            </div>
          </li>
        </ul>
        <div class="btn-group" v-if="!table4">
          <div class="btn-div textRight">
            <button class="primary-but" @click="handleSave" v-if="fatSure">
              确认
            </button>
          </div>
          <div class="btn-div textLeft">
            <button
              class="info-but"
              @click="decideComplat()"
              v-if="fatComplaint"
            >
              投诉
            </button>
          </div>
        </div>
        <div class="btn-group" v-if="table4 && personTel === userNameInfo">
          <div class="btn-div textRight">
            <button class="primary-but" @click="handleSave" v-if="fatSure">
              确认
            </button>
          </div>
          <div class="btn-div textLeft">
            <button
              class="info-but"
              @click="decideComplat()"
              v-if="fatComplaint"
            >
              投诉
            </button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="投诉意见"
      :show-close="false"
      :visible.sync="showComplaint"
      width="30%"
    >
      <el-upload
        :file-list="fileListC"
        :on-remove="removeFile"
        :before-remove="removeFile"
        :on-success="successFile"
        :on-error="errorFile"
        ref="upload"
        :before-upload="beforeUpload"
        :headers="headerMsg"
        :on-change="filechange"
        :action="uploadURL"
        drag
        :limit="1"
        :on-exceed="handleExceed"
        :auto-upload="false"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <!-- <div tabindex="0" class="el-upload el-upload--picture-card">
                <i class="el-icon-plus"></i>
              </div> -->
        <el-button icon="el-icon-upload" type="text">文件上传</el-button>
        <div slot="tip" class="el-upload__tip">上传文件不超过100MB</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <div class="btn-group">
          <div class="btn-div textRight">
            <button class="info-but" @click="cancelComplaint()">取 消</button>
          </div>
          <div class="btn-div textLeft">
            <button class="primary-but" @click="handleSubmit()">上 传</button>
          </div>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="新增来杭人员"
      :visible.sync="showAddPeople"
      width="30%"
      label-position="left"
    >
      <el-form
        :model="personForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="personForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input v-model="personForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-group">
        <div class="btn-div textRight">
          <button class="primary-but" @click="submitForm('ruleForm')">
            确 定
          </button>
        </div>
        <div class="btn-div textLeft">
          <button class="info-but" @click="cancel">取消</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { openOther } from '@/utils'
import Cookies from 'js-cookie'
export default {
  data () {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不为空'))
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('请输入正确手机号'))
      } else {
        callback()
      }
    }
    return {
      personTel: '',
      userNameInfo: '',
      allshow: true,
      complaintShow: true,
      complaintFileShow: true, // 投诉附件展示
      attachmentShow: true,
      fatResult: {
        testlistno: '',
        fatnumber: '',
        fatstarttime: '',
        fatendtime: '',
        saleFatLocationEntityList: [],
        saleFatDevicesEntityList: [],
        saleFatResultEntityList: [],
        bgstarttime: '',
        bgendtime: ''
      },
      infoMeetingResult: {
        bpmtableno: '',
        changedate: '',
        contractno: '',
        createdate: '',
        customerno: '',
        demandno: '',
        enddate: '',
        id: 1,
        ischange: '0',
        meetingno: '',
        meetingtopical: '',
        meetingtype: '设计联络会',
        projectname: '',
        projid: '',
        projno: '',
        saleMeetingPeoplesEntityList: [],
        startdate: '',
        state: '',
        supparticipants: ''
      },
      infoParcelResult: {
        cable: '',
        companycode: '',
        companyname: '',
        contractno: '',
        createdate: '',
        customerno: '',
        demandno: '',
        erplistno: '',
        expresscompany: '',
        id: 1,
        mainpart: '',
        other: '',
        plandelivertime: '',
        projid: '',
        projname: '',
        s2bbillno: '',
        shipmentcompany: '',
        shipmentcompanytele: '',
        shipmenttype: '',
        state: '',
        supconcoordinatepersonname: '',
        supconcoordinatepersontele: '',
        supconlogisticspersontele: '',
        toaddress: '',
        tocompany: '',
        topersonname: '',
        topersontele: '',
        totalcasenum: '',
        transporttime: '',
        waybillno: '',
        woodencasel: '',
        woodencasem: ''
      },
      infoServiceResult: {
        bpmTableNo: '',
        contractNo: '',
        createDate: '',
        customerNo: '',
        demandNo: '',
        id: 1,
        projectname: '',
        projectId: '',
        projno: '',
        saleServiceRecordsEntityList: [],
        serviceNo: '',
        servicetimes: '',
        state: '',
        totalServiceTimes: ''
      },
      msg: '',
      table1: true,
      table2: false,
      table3: false,
      table4: false,
      FATname: [],
      choose: [],
      choice: [],
      fatChoice: [],
      meetingChoice: [],
      meetingState: '', // 会议状态
      serviceChoice: [],
      serviceState: '',
      fatChoose: [], // fat下拉列表
      fatState: '', // fat下拉状态
      comeFileList: [],
      suggestion: [], // 投诉意见
      setFileList: [], // 投诉传参
      btstate: '',
      changeInfo: '',
      option: [
        {
          value: '项目会议',
          key: 4,
          color: '#b8bec5',
          disabled: false,
          name: 'meeting'
        },
        {
          value: 'FAT',
          key: 8,
          color: '#b8bec5',
          disabled: false,
          name: 'fat'
        },
        {
          value: '系统发运清单',
          key: 9,
          color: '#b8bec5',
          disabled: false,
          name: 'parcel'
        },
        {
          value: '工程服务记录',
          key: 17,
          color: '#b8bec5',
          disabled: false,
          name: 'service'
        }
      ],
      fileListC: [], // 上传组件初始化数据
      fileListS: [], // 要提交的数据
      fileListL: [], // 已选文件
      newComFileList: [],
      downloadURL: '',
      headerMsg: {
        token: Cookies.get('tokensp')
      },
      uploadURL: `${window.SITE_CONFIG['trainURL']}/alioss/sysossali/aliOssUploadAttachment`,
      fileNeedName: '',
      file: '',
      complaint: [], // 文字内容
      complaintIndex: 0,
      showComplaint: false,
      relatedDocuments: [[]],
      selectList: [],
      dataForm: {
        customerAccount: '',
        username: ''
      },
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1, // 跳转页
      showAddPeople: false,
      isAgree: false,
      submitORno: true,
      rules: {
        name: [{ required: true, message: '名字不为空', trigger: 'blur' }],
        phone: [{ validator: checkAge, trigger: 'blur', required: true }]
      },
      form: {
        name: '',
        number: '',
        date1: '',
        date3: ''
      },
      personForm: {
        name: '',
        phone: ''
      },
      fatSure: false,
      fatComplaint: false,
      suggestionShow: true,
      FATnumber: '',
      fillover: false,
      fillAdd: false,
      isAdd: true,
      cotDisagree: true,
      conIndex: 0
    }
  },
  computed: {
    hasToken () {
      return !!Cookies.get('tokensp')
    }
  },
  watch: {
    hasToken (newVal) {
      // console.log('hasToken', newVal)
      if (newVal) {
        if (this.websocket) {
        } else {
          this.initWebSocket()
        }
      } else if (this.websocket) {
        this.websocket.close()
      }
    }
  },
  methods: {
    clickItem (i, index) {
      if (i.disabled) {
        return
      }
      this.fatSure = false
      this.fatComplaint = false
      this.suggestionShow = true // 投诉意见
      this.complaintFileShow = true // 投诉附件
      this.attachmentShow = true // 附件
      this.msg = String(index + 1)
      if (index === 0) {
        this.complaintIndex = 0
        this.infoMeeting()
        this.table1 = true
        this.table2 = false
        this.table3 = false
        this.table4 = false
        // if(this.fatnumber.toString().substr(7,1) === '1'){
        //     this.isAgree = true
        //     this.fatSure = false
        //     this.fatComplaint = false
        // }
        // else if (this.fatnumber.toString().substr(7,1) === '4'){
        //     this.isAgree = false
        //     this.fatSure = true
        //     this.fatComplaint  = true
        // }
        // else{
        //      this.isAgree = false
        //     this.fatSure = false
        //     this.fatComplaint = false
        // }
      } else if (index === 1) {
        this.complaintIndex = 1
        // 会议详情
        this.FATinfo()
        this.table1 = false
        this.table2 = true
        this.table3 = false
        this.table4 = false
        // if (this.fatnumber.toString().substr(3,1) === '1'){
        //     this.fatSure = true
        //     this.fatComplaint  = true
        // }else{
        //     this.fatSure = false
        //     this.fatComplaint = false
        // }
      } else if (index === 2) {
        this.complaintIndex = 2
        // 发货详情
        this.infoParcel()
        this.table1 = false
        this.table2 = false
        this.table3 = true
        this.table4 = false
      } else if (index === 3) {
        this.complaintIndex = 3
        // 工程详情
        this.infoService()
        this.table1 = false
        this.table2 = false
        this.table3 = false
        this.table4 = true
      }
    },
    delFiles (item, index) {
      // this.comeFileList[this.complaintIndex].splice(index, 1)
      // this.setFileList[this.complaintIndex].splice(this.setFileList[this.complaintIndex].findIndex(res => {
      //   return res.filename === item.filename
      // }), 1)
      this.$http
        .post(
          `${window.SITE_CONFIG['trainURL']}/alioss/sysossali/deleteAliOss/${
            this.comeFileList[this.complaintIndex][index].aliOssId
          }`
        )
        .then((data) => {
          this.comeFileList[this.complaintIndex].splice(index, 1)
          this.setFileList[this.complaintIndex].splice(
            this.setFileList[this.complaintIndex].findIndex((res) => {
              return res.filename === item.filename
            }),
            1
          )
          // console.log(this.comeFileList[this.complaintIndex])
        })
        .catch(() => {})
    },
    // 下载文档
    download (item) {
      // console.log(item)
      var a = document.createElement('a')
      a.href = item.url
      a.setAttribute('href', a.href)
      a.setAttribute('target', '_blank')
      a.click()
      // document.body.removeChild(a)
    },
    handleShowComplaint () {
      this.showComplaint = true
    },
    cancelComplaint () {
      this.$refs.upload.clearFiles()
      this.showComplaint = false
    },
    cancel () {
      this.showAddPeople = false
    },
    // 删除文件
    removeFile (file, fileList) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId && file.save) {
        let index = this.fileListS.findIndex((item) => {
          return item.ossId === file.ossId
        })
        if (index > -1) {
          this.delUrls.push(this.fileListS[index].ossId)
          this.fileListS.splice(index, 1)
        }
      } else if (file.uid) {
        let index = this.fileListS.findIndex((item) => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http
            .post(
              `${window.SITE_CONFIG['trainURL']}/alioss/sysossali/deleteAliOss/${this.fileListS[index].ossId}`
            )
            .then((item) => {
              this.fileListS.splice(index, 1)
            })
            .catch(() => {})
        }
      }
    },
    // 上传成功
    successFile (response, file, fileList) {
      console.log(response)
      window.INDEX--
      this.conIndex++
      // this.fileListL = fileList
      //  this.fileListL.forEach(item =>{
      try {
        // console.log(file)
        this.fileNeedName = file.name
        let a = this.fileNeedName.indexOf('.')
        if (
          this.comeFileList[this.complaintIndex] &&
          this.comeFileList[this.complaintIndex].length
        ) {
          //  this.relatedDocuments[this.complaintIndex].push({
          //    filename:file.name,
          //    filevideoname:this.fileNeedName.substr(0,a),
          //    url: file.response.result.data.url,
          //    aliOssId: file.response.result.data.id,
          //  })
          this.comeFileList[this.complaintIndex].push({
            delId: true,
            filename: file.name,
            filevideoname: this.fileNeedName.substr(0, a),
            url: file.response.result.data.url,
            aliOssId: file.response.result.data.id
          })
          //  this.showComplaint = false
          this.$refs.upload.clearFiles()
        } else {
          let arr = []
          arr.push({
            delId: true,
            filename: file.name,
            filevideoname: this.fileNeedName.substr(0, a),
            url: file.response.result.data.url,
            aliOssId: file.response.result.data.id
          })
          //  this.relatedDocuments[this.complaintIndex] = arr
          this.comeFileList[this.complaintIndex] = arr

          //  this.showComplaint = false
          this.$refs.upload.clearFiles()
        }
        //  console.log(this.comeFileList[this.complaintIndex])
        // })
        //  this.$set(this.relatedDocuments, this.complaintIndex,this.relatedDocuments[this.complaintIndex])
        this.$set(
          this.comeFileList,
          this.complaintIndex,
          this.comeFileList[this.complaintIndex]
        )
        if (
          this.setFileList[this.complaintIndex] &&
          this.setFileList[this.complaintIndex].length
        ) {
          //  this.relatedDocuments[this.complaintIndex].push({
          //    filename:file.name,
          //    filevideoname:this.fileNeedName.substr(0,a),
          //    url: file.response.result.data.url,
          //    aliOssId: file.response.result.data.id,
          //  })
          this.setFileList[this.complaintIndex].push({
            filename: file.name,
            filevideoname: this.fileNeedName.substr(0, a),
            url: file.response.result.data.url,
            aliOssId: file.response.result.data.id
          })
          this.showComplaint = false
          this.$refs.upload.clearFiles()
        } else {
          let arr = []
          arr.push({
            filename: file.name,
            filevideoname: this.fileNeedName.substr(0, a),
            url: file.response.result.data.url,
            aliOssId: file.response.result.data.id
          })
          //  this.relatedDocuments[this.complaintIndex] = arr
          this.setFileList[this.complaintIndex] = arr
          this.showComplaint = false
          this.$refs.upload.clearFiles()
        }
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        //  console.log(this.setFileList[this.complaintIndex])
        //  if (window.INDEX === 0) {
        //     this.$refs.upload.clearFiles()
        // console.log(this.relatedDocuments[this.complaintIndex])
        //  }
      } catch (error) {
        this.$message.error('上传文件失败，请检查原因')
        console.log(error)
      }
    },
    // 投诉
    decideComplat () {
      this.$confirm('是否投诉?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (this.complaint[this.complaintIndex]) {
            if (this.table1) {
              this.$http
                .post(
                  `${window.SITE_CONFIG['baseURL']}/fat/salefatresult/updateMeeting`,
                  {
                    params: {
                      id: this.infoMeetingResult.projid,
                      username: this.$store.getters.userInfo.username,
                      usertele: this.$store.getters.userInfo.mobile,
                      opinion: this.complaint[this.complaintIndex],
                      confirm: '0',
                      state: '0',
                      fileList: this.setFileList[this.complaintIndex],
                      meetingNo: this.infoMeetingResult.meetingno
                    }
                  }
                )
                .then((data) => {
                  this.$message({
                    message: '已经接收到您的投诉',
                    type: 'success'
                  })
                  this.fatSure = false
                  this.fatComplaint = false
                  this.infoMeeting()
                  this.fatNEW()
                  this.complaint[this.complaintIndex] = ''
                  // this.BALLcolor()
                })
                .catch(() => {
                  this.$message.error('投诉失败')
                })
            }
            if (this.table3) {
              this.$http
                .post(
                  `${window.SITE_CONFIG['baseURL']}/fat/salefatresult/updateParcel`,
                  {
                    params: {
                      id: this.infoParcelResult.projid,
                      username: this.$store.getters.userInfo.username,
                      usertele: this.$store.getters.userInfo.mobile,
                      opinion: this.complaint[this.complaintIndex],
                      confirm: '0',
                      state: '0',
                      fileList: this.setFileList[this.complaintIndex],
                      erplistno: this.infoParcelResult.erplistno
                    }
                  }
                )
                .then((data) => {
                  this.$message({
                    message: '已经接收到您的投诉',
                    type: 'success'
                  })
                  this.fatSure = false
                  this.fatComplaint = false
                  this.complaint[this.complaintIndex] = ''
                  this.relatedDocuments[this.complaintIndex] = []
                  this.comeFileList[this.complaintIndex] = []
                  this.setFileList[this.complaintIndex] = []
                  this.infoParcel()
                  this.fatNEW()
                  // this.BALLcolor()
                })
                .catch(() => {
                  this.$message.error('投诉失败')
                })
            }
            if (this.table4) {
              //  投诉
              this.$http
                .post(
                  `${window.SITE_CONFIG['baseURL']}/insale/serviceinfo/updateServicel`,
                  {
                    params: {
                      id: this.infoServiceResult.projectId,
                      //  'username':this.$store.getters.userInfo.username,
                      //  'usertele':this.$store.getters.userInfo.mobile,
                      opinion: this.complaint[this.complaintIndex],
                      confirm: '0',
                      //  'state':'0',
                      fileList: this.setFileList[this.complaintIndex],
                      serviceNo: this.infoServiceResult.serviceNo
                    }
                  }
                )
                .then((data) => {
                  this.$message({
                    message: '已经接收到您的投诉',
                    type: 'success'
                  })
                  this.fatSure = false
                  this.fatComplaint = false
                  this.infoService()
                  this.fatNEW()
                  this.complaint[this.complaintIndex] = ''
                  // this.BALLcolor()
                })
                .catch(() => {
                  this.$message.error('投诉失败')
                })
            }
          } else {
            this.$message({
              type: 'warning',
              message: '投诉意见不能为空'
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消投诉'
          })
          this.comeFileList[this.complaintIndex].forEach((item, index) => {
            this.delFiles(item, index)
            index--
          })
          this.complaint[this.complaintIndex] = ''
        })
    },
    // 上传失败
    errorFile (err, file, fileList) {
      this.$message.warning('上传失败，请重新上传')
      // this.fatSure = true
      // this.fatComplaint = true
    },
    beforeUpload (file) {
      // console.log(file)
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning(
          '文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号'
        )
        return false
      }
    },
    filechange (file, fileList) {
      // console.log(fileList)
      this.fileListL = fileList
    },
    // 确定
    handleSave () {
      // console.log(this.infoMeetingResult.meetingno)
      if (this.table1) {
        this.$http
          .post(
            `${window.SITE_CONFIG['baseURL']}/fat/salefatresult/updateMeeting`,
            {
              params: {
                id: this.infoMeetingResult.projid,
                username: this.$store.getters.userInfo.username,
                usertele: this.$store.getters.userInfo.mobile,
                opinion: '',
                confirm: '1',
                state: '1',
                fileList: [],
                meetingNo: this.infoMeetingResult.meetingno
              }
            }
          )
          .then((data) => {
            this.infoMeeting()
            this.fatNEW()
            // this.BALLcolor()
          })
          .catch(() => {})
      } else if (this.table3) {
        // console.log(
        //   this.infoParcelResult
        // )
        this.$http
          .post(
            `${window.SITE_CONFIG['baseURL']}/fat/salefatresult/updateParcel`,
            {
              params: {
                id: this.infoParcelResult.projid,
                username: this.$store.getters.userInfo.username,
                usertele: this.$store.getters.userInfo.mobile,
                opinion: '',
                confirm: '1',
                state: '1',
                erplistno: this.infoParcelResult.erplistno,
                fileList: []
              }
            }
          )
          .then((data) => {
            this.complaint[this.complaintIndex] = ''
            this.relatedDocuments[this.complaintIndex] = []
            this.infoParcel()
            this.fatNEW()
          })
          .catch(() => {})
      } else if (this.table4) {
        // 确认
        this.$http
          .post(
            `${window.SITE_CONFIG['baseURL']}/insale/serviceinfo/updateServicel`,
            {
              params: {
                id: this.infoServiceResult.projectId,
                //  'username':this.$store.getters.userInfo.username,
                //  'usertele':this.$store.getters.userInfo.mobile,
                opinion: '',
                confirm: '1',
                //  'state':'1',
                fileList: [],
                serviceNo: this.infoServiceResult.serviceNo
              }
            }
          )
          .then((data) => {
            this.infoService()
            this.fatNEW()
            // this.BALLcolor()
            this.fatSure = false
            this.fatComplaint = false
          })
          .catch(() => {})
      }
    },
    handleSubmit () {
      this.$refs.upload.submit()
      // window.INDEX = this.fileListL
      // console.log(this.fileListL)
      // // window.q = this.$refs.upload
      // if(this.fileListL.length != 0 ){
      //   console.log('nnono')
      //  this.$refs.upload.submit()
      // }else{
      //   console.log('come')
      //  if(this.table1){
      //   this.$http.post(`${window.SITE_CONFIG['baseURL']}/fat/salefatresult/updateMeeting`,{
      //      params:{
      //        'id': this.infoMeetingResult.projid,
      //        'username':this.$store.getters.userInfo.username,
      //        'usertele':this.$store.getters.userInfo.mobile,
      //        'opinion':this.complaint[this.complaintIndex],
      //        'confirm':'1',
      //        'state':'1',
      //        'fileList':this.relatedDocuments[this.complaintIndex]
      //      }
      //   }).then(data => {
      //       this.showComplaint = false
      //       this.infoMeeting()
      //       this.fatNEW()
      //       // this.BALLcolor()
      //   }).catch((err) => {
      //   })
      // }
      //  if (this.table3){
      //   this.$http.post(`${window.SITE_CONFIG['baseURL']}/fat/salefatresult/updateParcel`,{
      //      params:{
      //        'id': this.infoParcelResult.projid,
      //        'username':this.$store.getters.userInfo.username,
      //        'usertele':this.$store.getters.userInfo.mobile,
      //        'opinion':this.complaint[this.complaintIndex],
      //        'confirm':'1',
      //        'state':'1',
      //        'fileList':this.relatedDocuments[this.complaintIndex],
      //       'erplistno':this.infoParcelResult.erplistno,
      //      }
      //   }).then(data => {
      //     this.showComplaint = false
      //     this.infoParcel()
      //     this.fatNEW()
      //     // this.BALLcolor()
      //   }).catch((err) => {
      //   })
      // }
      //  if (this.table4){
      //   this.$http.post(`${window.SITE_CONFIG['baseURL']}/fat/salefatresult/updateServicel`,{
      //      params:{
      //        'id': this.infoServiceResult.projid,
      //        'username':this.$store.getters.userInfo.username,
      //        'usertele':this.$store.getters.userInfo.mobile,
      //        'opinion':this.complaint[this.complaintIndex],
      //        'confirm':'1',
      //        'state':'1',
      //        'fileList':this.relatedDocuments[this.complaintIndex]
      //      }
      //   }).then(data => {
      //     this.showComplaint = false
      //     this.infoService()
      //     this.fatNEW()
      //     // this.BALLcolor()
      //   }).catch((err) => {
      //   })
      // }
      // }
      // this.fatSure = false
      // this.fatComplaint = false
    },
    add () {
      this.showAddPeople = true
    },
    agree () {
      this.isAdd = false
      this.fillAdd = true
      this.fillover = false
      this.cotDisagree = true
      this.fatNEW()
      // this.BALLcolor()
    },
    disAgre () {
      this.isAdd = false
      this.isAgree = false
      this.fillAdd = false
      this.fillover = true
      this.cotDisagree = false
      this.fatNEW()
      // this.BALLcolor()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // debugger
          if (
            this.fatResult.saleFatLocationEntityList &&
            this.fatResult.saleFatLocationEntityList.length
          ) {
            this.fatResult.saleFatLocationEntityList.push({
              fatlocationperson: this.personForm.name,
              fatlocationtele: this.personForm.phone
            })
            this.showAddPeople = false
          } else {
            let arr = []
            arr.push({
              fatlocationperson: this.personForm.name,
              fatlocationtele: this.personForm.phone
            })
            this.fatResult.saleFatLocationEntityList = arr
            this.showAddPeople = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    // FAT下拉列表联动
    changeFatChoose (val) {
      this.fatResult.testlistno = val
      this.fatChoice.forEach((data) => {
        if (data.testlistno === val) {
          this.fatState = data.state
          this.fatResult.fatnumber = data.fatnumber
        }
      })
      this.FATinfo()
    },
    // FAT详情
    FATinfo () {
      this.$http
        .post(`${window.SITE_CONFIG['baseURL']}/fat/salefatresult/info`, {
          params: {
            customerno: this.$route.params.row.customerno,
            projid: this.$route.params.row.projid,
            topersontele: this.$store.state.userInfo.mobile,
            fatnumber: this.fatResult.fatnumber ? this.fatResult.fatnumber : ''
          }
        })
        .then((data) => {
          this.complaintIndex = 1
          this.complaintIndex = 1
          this.fatResult = data.result.data.saleFatInfo
          this.relatedDocuments[this.complaintIndex] =
            data.result.data.saleFatInfo.saleAppendfileEntityList
          // 下拉列表，联动取值
          if (data.result.data.testListNoList.length) {
            this.fatChoice = data.result.data.testListNoList
          } // 下拉选
          this.fatState = data.result.data.saleFatInfo.state
          if (data.result.data.saleFatInfo.customerConfirm === '0') {
            this.allshow = false
          } else {
            this.allshow = true
          }
          this.fatResult.fatnumber = data.result.data.saleFatInfo.fatnumber
          this.fatResult.testlistno = data.result.data.saleFatInfo.testlistno
          this.BALLcolor()
          if (this.fatState !== '1' && this.fatState !== '0') {
            this.isAgree = true
          } else {
            this.isAgree = false
          }
        })
        .catch(() => {})
    },
    // 会议详情下拉列表联动
    changeMeetingChoose (val) {
      this.infoMeetingResult.bpmtableno = val
      this.meetingChoice.forEach((data) => {
        if (data.bpmtableno === val) {
          this.infoMeetingResult.meetingno = data.meetingno
        }
      })
      this.infoMeeting()
    },
    // 会议详情
    infoMeeting () {
      this.$http
        .post(
          `${window.SITE_CONFIG['baseURL']}/fat/salefatresult/infoMeeting`,
          {
            params: {
              id: this.$route.params.row.projid,
              customerNo: this.$route.params.row.customerno,
              userTeleNo: this.$store.state.userInfo.mobile,
              meetingNo: this.infoMeetingResult.meetingno
                ? this.infoMeetingResult.meetingno
                : ''
              // 'meetingNo' : 'S2B042020022914400409700'
            }
          }
        )
        .then((data) => {
          // 下拉列表，联动取值
          if (data.result.meetingList.length) {
            this.meetingChoice = data.result.meetingList
          }
          this.complaintIndex = 0
          this.infoMeetingResult = data.result.meeting
          this.relatedDocuments[this.complaintIndex] =
            data.result.meeting.saleAppendfileEntityList
          this.comeFileList[this.complaintIndex] =
            data.result.meeting.saleConfirmFileList
          this.suggestion = data.result.meeting.saleMeetingConfirmCommentList
          this.infoMeetingResult.state = data.result.meeting.state
          this.infoMeetingResult.meetingno = data.result.meeting.meetingno
          this.BALLcolor()
          // 下拉列表状态对应按钮
          if (
            data.result.meeting.state !== '2' &&
            data.result.meeting.state !== '3'
          ) {
            this.fatSure = true
            this.fatComplaint = true
            this.complaintShow = true // 设置投诉意见是否显示
          } else {
            this.fatSure = false
            this.fatComplaint = false
            this.complaintShow = false // 设置投诉意见是否显示
          }
          // this.complaint[complaintIndex] = data.result.saleServiceConfirmCommentList[0].opinion
          // this.relatedDocuments[this.complaintIndex] = data.result.meeting.saleAppendfileEntityList
          // this.comeFileList[this.complaintIndex] = data.result.meeting.saleConfirmFileList
          // this.suggestion = data.result.meeting.saleMeetingConfirmCommentList
        })
        .catch(() => {})
    },
    // 发货详情+下拉选
    infoParcel () {
      this.$http
        .post(
          `${window.SITE_CONFIG['baseURL']}/fat/salefatresult/infoParcelList`,
          {
            params: {
              customerno: this.$route.params.customerCode,
              userteleno: this.$store.getters.userInfo.mobile,
              projid: this.$route.params.row.projid
              // 'id': this.$route.params.customerCode
            }
          }
        )
        .then((data) => {
          this.choose = []
          this.complaintIndex = 2
          this.infoParcelResult = data.result.parcel // 第一次显示页面数据
          this.choice = data.result.parcelList // 下拉选
          this.choice.forEach((item) => {
            this.choose.push({
              value: item.erplistno,
              label: item.erplistno
            })
            this.relatedDocuments[this.complaintIndex] =
              data.result.parcel.saleAppendfileEntityList
            this.comeFileList[this.complaintIndex] =
              data.result.parcel.saleConfirmFileList
            this.suggestion =
              data.result.parcel.saleParcelinfoConfirmCommentList
            // this.complaint[this.]
            this.changeInfo = this.infoParcelResult.erplistno // 默认值
            // let a =  this.fatnumber.toString().split('')
            // a.splice(8,1,this.infoParcelResult.state)
            // this.fatnumber = a.join('')
            this.btstate = this.infoParcelResult.state
            // console.log(this.btstate)
            // console.log(this.fatnumber)
            this.BALLcolor()
          })
        })
        .catch(() => {})
    },
    // 工程服务详情下拉列表联动
    changeServiceChoose (val) {
      this.infoServiceResult.bpmTableNo = val
      this.serviceChoice.forEach((data) => {
        if (data.bpmTableNo === val) {
          this.infoServiceResult.serviceNo = data.serviceNo
        }
      })
      this.infoService()
    },
    // 工程详情
    infoService () {
      this.suggestionShow = true
      this.complaintFileShow = true
      this.attachmentShow = true
      this.$http
        .post(
          `${window.SITE_CONFIG['baseURL']}/insale/serviceinfo/infoService`,
          {
            params: {
              id: this.$route.params.row.projid,
              customerNo: this.$route.params.row.customerno,
              serviceNo: this.infoServiceResult.serviceNo
                ? this.infoServiceResult.serviceNo
                : ''
            }
          }
        )
        .then((data) => {
          this.complaintIndex = 3
          this.infoServiceResult = data.result.service
          this.personTel = data.result.service.personTel
          // 附件
          // this.relatedDocuments[this.complaintIndex] = data.result.service.saleAppendfileEntityList
          this.relatedDocuments[this.complaintIndex] =
            data.result.service.appendFileList
          //  投诉附件
          //  this.comeFileList[this.complaintIndex] = data.result.service.saleConfirmFileList
          this.comeFileList[this.complaintIndex] =
            data.result.service.confirmFileList
          //  投诉意见
          // this.suggestion = data.result.service.saleServiceConfirmCommentList
          this.suggestion = data.result.service.confirmCommentList
          if (data.result.serviceList.length) {
            this.serviceChoice = data.result.serviceList
          }
          this.infoServiceResult.state = data.result.service.state
          this.infoServiceResult.serviceNo = data.result.service.serviceNo
          this.BALLcolor()
          // 状态（1 待客户确认，2 已确认，3 已投诉，4 制单）
          // 已确认、已投诉显示处理信息
          if (
            this.infoServiceResult.state !== '2' &&
            this.infoServiceResult.state !== '3'
          ) {
            this.suggestionShow = false // 不展示处理信息
          }
          // 已投诉显示投诉附件
          if (this.infoServiceResult.state !== '3') {
            this.complaintFileShow = false // 不展示投诉附件
          }
          // 已制单附件不显示
          if (this.infoServiceResult.state === '4') {
            this.attachmentShow = false // 不显示附件
          }
          if (
            this.infoServiceResult.state !== '2' &&
            this.infoServiceResult.state !== '3' &&
            this.infoServiceResult.state !== '4'
          ) {
            this.fatSure = true // 确认按钮
            this.fatComplaint = true // 投诉按钮
            this.complaintShow = true // 投诉意见
            this.suggestionShow = false // 隐藏处理意见
          } else {
            this.fatSure = false
            this.fatComplaint = false
            this.complaintShow = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 最新17碼
    fatNEW () {
      this.$http
        .post(
          `${window.SITE_CONFIG['baseURL']}/fat/salefatresult/projectDetailsList`,
          {
            params: {
              customerno: this.$route.params.customerCode,
              userteleno: this.$store.getters.userInfo.mobile,
              projid: this.$route.params.row.projid
            }
          }
        )
        .then((data) => {
          this.fatnumber = data.result[0].state
          // console.log(this.fatnumber)
          this.BALLcolor()
        })
        .catch(() => {})
    },
    projectDetailsList () {
      this.$http
        .post(
          `${window.SITE_CONFIG['baseURL']}/fat/salefatresult/projectDetailsList`,
          {
            params: {
              customerno: this.$route.params.customerCode,
              userteleno: this.$store.getters.userInfo.mobile,
              projid: this.$route.params.row.projid
            }
          }
        )
        .then((data) => {
          let arr = []
          this.FATname = data.result
          this.option.map((item) => {
            let disabled = true
            this.FATname.forEach((f) => {
              if (item.name === f.tablename) {
                disabled = false
              }
            })
            item.disabled = disabled
          })
          this.FATname.forEach((item) => {
            arr.push(item.tablename)
          })
          this.BALLcolor()
          if (arr.indexOf('fat') > -1) {
            this.table1 = false
            this.table2 = true
            this.table3 = false
            this.table4 = false
            this.msg = 2
            this.FATinfo()
          } else if (arr.indexOf('meeting') > -1) {
            this.table1 = true
            this.table2 = false
            this.table3 = false
            this.table4 = false
            this.msg = 1
            this.infoMeeting()
          } else if (arr.indexOf('parcel') > -1) {
            this.table1 = false
            this.table2 = false
            this.table3 = true
            this.table4 = false
            this.msg = 3
            this.infoParcel()
          } else if (arr.indexOf('service') > -1) {
            this.table1 = false
            this.table2 = false
            this.table3 = false
            this.table4 = true
            this.msg = 4
            this.infoService()
          }
        })
        .catch(() => {})
    },
    // 填写来杭人员的保存按钮
    fillIn () {
      this.updateFAT()
    },
    fillTime () {
      this.updateFAT()
    },
    reback () {
      this.isAdd = true
      this.FATinfo()
    },
    updateFAT () {
      if (this.fillAdd) {
        this.$http
          .post(`${window.SITE_CONFIG['baseURL']}/fat/salefatresult/update`, {
            params: {
              fatnumer: this.fatResult.fatnumber,
              // 'testlistno':'1',
              testlistno: this.fatResult.testlistno,
              // 'result':this.fatResult.result,
              bgstarttime: '',
              bgendtime: '',
              isfatlocation: this.fatResult.isfatlocation,
              status: '1',
              fatpersons: this.fatResult.saleFatLocationEntityList
            }
          })
          .then((data) => {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.fatNEW()
            this.FATinfo()
            this.fillAdd = false
            this.isAdd = true
          })
          .catch(() => {
            this.$message.error('保存失败')
          })
      }
      if (this.fillover) {
        this.$http
          .post(`${window.SITE_CONFIG['baseURL']}/fat/salefatresult/update`, {
            params: {
              fatnumer: this.fatResult.fatnumber,
              testlistno: this.fatResult.testlistno,
              // 'result':this.fatResult.result,
              bgstarttime: this.fatResult.bgstarttime,
              bgendtime: this.fatResult.bgendtime,
              isfatlocation: '0',
              status: '0',
              fatpersons: this.fatResult.saleFatLocationEntityList
            }
          })
          .then((data) => {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.fatNEW()
            this.FATinfo()
            this.fillAdd = false
            this.isAdd = true
          })
          .catch(() => {
            this.$message.error('保存失败')
          })
      }
    },
    BALLcolor () {
      // FAT颜色
      this.FATname.forEach((item) => {
        // console.log(item)
        try {
          if (item.tablename.includes('fat')) {
            if (this.fatnumber.toString().substr(7, 1) === '0') {
              this.option[1].color = '#b8bec5'
            } else if (this.fatnumber.toString().substr(7, 1) === '1') {
              this.option[1].color = '#f0b54f'
            } else if (this.fatnumber.toString().substr(7, 1) === '2') {
              this.option[1].color = '#428bd1'
            } else if (this.fatnumber.toString().substr(7, 1) === '3') {
              this.option[1].color = '#428bd1'
            } else if (this.fatnumber.toString().substr(7, 1) === '4') {
              this.option[1].color = '#428bd1'
            } else if (this.fatnumber.toString().substr(7, 1) === '5') {
              this.option[1].color = '#428bd1'
            }
          }
          // 项目会议颜色
          if (item.tablename.includes('meeting')) {
            if (this.fatnumber.toString().substr(3, 1) === '0') {
              this.option[0].color = '#b8bec5'
            } else if (this.fatnumber.toString().substr(3, 1) === '1') {
              this.option[0].color = '#f0b54f'
            } else if (this.fatnumber.toString().substr(3, 1) === '2') {
              this.option[0].color = '#428bd1'
            } else if (this.fatnumber.toString().substr(3, 1) === '3') {
              this.option[0].color = '#428bd1'
            }
          }
          // 系统发运单
          if (item.tablename.includes('parcel')) {
            if (this.fatnumber.toString().substr(8, 1) === '0') {
              this.option[2].color = '#b8bec5'
            } else if (this.fatnumber.toString().substr(8, 1) === '1') {
              this.option[2].color = '#f0b54f'
            } else if (this.fatnumber.toString().substr(8, 1) === '2') {
              this.option[2].color = '#428bd1'
            } else if (this.fatnumber.toString().substr(8, 1) === '3') {
              this.option[2].color = '#428bd1'
            }
          }
          // 工程服务记录
          if (item.tablename.includes('service')) {
            if (this.fatnumber.toString().substr(16, 1) === '0') {
              this.option[3].color = '#b8bec5'
            } else if (this.fatnumber.toString().substr(16, 1) === '1') {
              this.option[3].color = '#f0b54f'
            } else if (this.fatnumber.toString().substr(16, 1) === '2') {
              this.option[3].color = '#428bd1'
            } else if (this.fatnumber.toString().substr(16, 1) === '3') {
              this.option[3].color = '#428bd1'
            } else if (this.fatnumber.toString().substr(16, 1) === '4') {
              this.option[3].color = '#f0b54f'
            }
          }
        } catch (error) {
          console.log(error)
        }
      })
      // debugger
      // FAT按钮
      if (this.table2) {
        if (this.fatnumber.toString().substr(7, 1) === '0') {
          this.isAgree = false
        } else if (this.fatnumber.toString().substr(7, 1) === '1') {
          // this.option[0].color = '#f0b54f'
          this.isAgree = true
        } else if (this.fatnumber.toString().substr(7, 1) === '2') {
          // this.option[0].color = '#428bd1'
          this.isAgree = false
        } else if (this.fatnumber.toString().substr(7, 1) === '3') {
          // this.option[0].color = '#428bd1'
          this.isAgree = false
        } else if (this.fatnumber.toString().substr(7, 1) === '4') {
          // this.option[0].color = '#428bd1'
          this.isAgree = false
        } else if (this.fatnumber.toString().substr(7, 1) === '5') {
          // this.option[0].color = '#428bd1'
          this.isAgree = false
        }
      }

      // 项目会议按钮
      if (this.table1) {
        if (this.fatnumber.toString().substr(3, 1) === '0') {
          // this.option[1].color = '#b8bec5'
          this.fatSure = false
          this.fatComplaint = false
        } else if (this.fatnumber.toString().substr(3, 1) === '1') {
          // this.option[1].color = '#f0b54f'
          this.fatSure = true
          this.fatComplaint = true
        } else if (this.fatnumber.toString().substr(3, 1) === '2') {
          // this.option[1].color = '#428bd1'
          this.fatSure = false
          this.fatComplaint = false
        } else if (this.fatnumber.toString().substr(3, 1) === '3') {
          // this.option[1].color = '#428bd1'
          this.fatSure = false
          this.fatComplaint = false
        }
      }
      // 系统发运单按钮
      if (this.table3) {
        // debugger
        if (this.btstate === '0') {
          // this.option[2].color = '#b8bec5'
          this.fatSure = true
          this.fatComplaint = true
          this.complaintShow = true // 设置投诉意见是否显示
        } else if (this.btstate === '1') {
          // this.option[2].color = '#f0b54f'
          this.fatSure = false
          this.fatComplaint = false
          this.complaintShow = false
        } else if (this.btstate === '2') {
          // debugger
          // this.option[2].color = '#428bd1'
          this.fatSure = false
          this.fatComplaint = false
          this.complaintShow = false // 设置投诉意见是否显示
        } else if (this.btstate === '3') {
          // this.option[2].color = '#428bd1'
          this.fatSure = false
          this.fatComplaint = false
          this.complaintShow = false
        }
      }
      if (this.table4) {
        // 工程服务记录
        if (this.fatnumber.toString().substr(16, 1) === '0') {
          // this.option[3].color = '#b8bec5'
          this.fatSure = false
          this.fatComplaint = false
        } else if (this.fatnumber.toString().substr(16, 1) === '1') {
          // this.option[3].color = '#f0b54f'
          this.fatSure = true
          this.fatComplaint = true
        } else if (this.fatnumber.toString().substr(16, 1) === '2') {
          // this.option[3].color = '#428bd1'
          this.fatSure = false
          this.fatComplaint = false
        } else if (this.fatnumber.toString().substr(16, 1) === '3') {
          // this.option[3].color = '#428bd1'
          this.fatSure = false
          this.fatComplaint = false
        }
      }
    },
    changeChoose (val) {
      this.relatedDocuments[this.complaintIndex] = []
      this.complaint[this.complaintIndex] = ''
      //  this.complaint[this]
      this.$http
        .post(`${window.SITE_CONFIG['baseURL']}/fat/salefatresult/infoParcel`, {
          params: {
            erplistno: val
            // 'id': this.$route.params.customerCode
          }
        })
        .then((data) => {
          this.complaintIndex = 2
          this.infoParcelResult = data.result
          this.relatedDocuments[this.complaintIndex] =
            data.result.saleAppendfileEntityList
          this.comeFileList[this.complaintIndex] =
            data.result.saleConfirmFileList
          this.suggestion = data.result.saleParcelinfoConfirmCommentList
          this.btstate = data.result.state
          this.BALLcolor()
        })
        .catch(() => {})
    },
    handleDel (index) {
      // 删除人
      this.fatResult.saleFatLocationEntityList.splice(index, 1)
    },
    rdmsHandle () {
      let u = navigator.userAgent
      let isApp =
        u.indexOf('Android') > -1 ||
        u.indexOf('Adr') > -1 ||
        !!u.match(/\(i[^]+( U)? CPU.+Mac OS X/) // ios终端
      if (this.hasToken && this.$store.state.userInfo.jwtStr !== '') {
        openOther(
          window.SITE_CONFIG['rdmsUrl'] + this.$store.state.userInfo.jwtStr,
          true
        )
      } else {
        if (isApp) {
          this.$router.push({ name: 'rdms' })
        } else {
          openOther('rdms')
        }
      }
    },
    // 获取当前用户状态
    getUserStatus () {
      this.$http
        .get(
          `${window.SITE_CONFIG['forumURL']}/integral/integralorder/isGetIntegral`
        )
        .then((data) => {
          if (data.result.code === 0) {
            this.userStatus = data.result.user
          }
        })
        .catch(() => {})
    },
    // 初始化websocket
    initWebSocket () {
      const wsuri = window.SITE_CONFIG['websocket'] // ws地址
      if (!window.WebSocket) {
        window.WebSocket = window.MozWebSocket
      }
      if (window.WebSocket) {
        this.websocket = new WebSocket(wsuri)
        this.websocket.onopen = this.websocketonopen
        this.websocket.onerror = this.websocketonerror
        this.websocket.onmessage = this.websocketonmessage
        this.websocket.onclose = this.websocketclose
      } else {
        // console.log('您的浏览器不支持WebSocket协议！')
      }
    },
    getUserInfo () {
      this.$request.get(`/sys/user/registerInfo`).then((data) => {
        this.userNameInfo = data.user.username
      })
    }
  },
  created () {
    this.getUserInfo()
  },
  mounted () {
    this.fatnumber = this.$route.params.row.state
    this.projectDetailsList()
    // this.BALLcolor()
    if (this.hasToken) {
      this.getUserStatus()
      if (this.websocket) {
      } else {
        this.initWebSocket()
      }
    }
  }
}
</script>

<style>
.left {
  width: 100%;
  height: 180px;
  padding-top: 20px;
  padding-left: 20px;
}
.right {
  /* height: calc(100vh - 150px); */
  /* overflow-y: scroll; */
  margin: auto;
  width: 80%;
}
.item {
  display: inline-block;
  height: 100px;
  padding: 20px;
  width: 25%;
  position: relative;
}
.el-timeline-item__tail1 {
  position: absolute;
  left: 4px;
  height: 100%;
  border-top: 2px solid #e4e7ed;
}
.icon {
  position: absolute;
  left: 4px;
  top: 20px;
}
.futitle {
  color: #ccc;
  font-size: 13px;
}
.circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 0 auto;
  /* cursor: pointer; */
  /* background: red */
}
.line {
  border-top: 2px dashed #cccccc;
  height: 1px;
  overflow: hidden;
  width: 70%;
  position: absolute;
  left: 65%;
  bottom: 55%;
}
.title {
  font-size: 14px;
  padding-top: 20px;
  text-align: center;
  width: 100px;
  margin: 0 auto;
  /* cursor: pointer; */
}
.service {
  font-size: 20px;
  font-weight: bolder;
  padding-left: 20px;
  padding-right: 20px;
}

#tab1 {
  border-collapse: collapse; /*外边框-折叠：折叠*/
  text-align: center; /*文本-对齐：居中*/
  width: 100%; /*高度*/
  margin: 18px 10px 18px 1px; /*内边框：上20px 右：自动*/
  font-family: Microsoft YaHei;
  color: #333333;
  font-size: 14px;
  border: 1px solid #ebeef5;
}
.left_title {
  width: 30%; /*高度*/
  background-color: #f6f7f7;
}
.bottom_border {
  text-align: left;
  padding-left: 10px;
}
tr {
  height: 45px;
}
.conte {
  font-size: 20px;
  padding: 10px 0;
}
.bottomThird {
  border-top: 1px solid #eee;
}
.table2ZT {
  display: inline-block;
  padding: 10px 20px;
}
.table2form {
  padding: 0 20px;
}
.divcss1 {
  display: inline-block;
  width: 50%;
  padding: 0px 20px;
}
.conent {
  width: 970px;
  padding: 20px 20px;
}
.search-row {
  display: flex;
}
.search-conent {
  min-width: 350px;
  margin-right: 20px;
}
.search-but {
  width: 100%;
  min-width: 200px;
  text-align: right;
  display: flex;
}
.opt-row {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
}
.opt-right {
  width: 300px;
}
.opt-left {
  width: 100%;
  text-align: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.info-but-new {
  background: #1d65a8;
  color: #ffffff;
}
.but-file {
  background-color: #ffffff;
  border: none;
}
.demand-desc {
  width: 100%;
  cursor: pointer;
}
.tip {
  max-width: 500px;
  word-wrap: break-word;
  word-break: break-all;
}
.red {
  color: red;
}
.detail-icon {
  cursor: pointer;
}
.detail-icon:hover {
  color: #1d65a8;
}
.tooltip-content {
  width: 60px;
  text-align: center;
  border-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.card {
  display: flex;
}
.cardTitle {
  padding: 0 20px;
  font-weight: bold;
  flex: 1;
  text-align: left;
  font-size: 16px;
}
.cardSubtitle {
  padding: 0 20px;
  flex: 1;
  text-align: right;
  font-size: 16px;
  color: #ccc;
}
.doclist {
  padding: 20px;
  overflow-y: hidden;
  overflow-x: scroll;
  display: flex;
  cursor: pointer;
}
/* .doclist::-webkit-scrollbar {
    display: none;
} */
.doclist li {
  margin-right: 2%;
}
.doclist li img {
  width: 85px;
  height: 85px;
  display: block;
  margin: 0 auto;
}
.doclist li p {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.complaintTextarea {
  /* padding: 20px; */
  margin-bottom: 20px;
}
.textLeft {
  text-align: left;
}
.textRight {
  text-align: right;
}
.center {
  text-align: center;
}
.btn-group {
  padding-top: 20px;
  width: 100%;
  min-width: 200px;
  text-align: center;
  display: flex;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.primary-but {
  background: #1d65a8;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.primary-but:hover {
  background: #ffffff;
  color: #1d65a8;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.btn-div {
  flex: 1;
}
.addPerson {
  background-color: #eee;
  /* padding: 0 4%; */
  display: inline-block;
  width: 10%;
  margin: 20px 7%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
}
.add-but {
  background: #ffffff;
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.add-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.tableLeft {
  width: 48%;
  display: inline-block;
}
.tableRight {
  width: 48%;
  /* display:inline-block; */
  float: right;
}
.dekk {
  padding-left: 20px;
}
.dekk:hover {
  color: red;
}
.pref {
  padding: 10px 20px;
}
.el-upload {
  width: 100%;
}
.el-dialog__header {
  background-color: #1d65a8;
  color: #ffffff;
}
.el-dialog__title {
  color: #ffffff;
}
.el-upload-dragger {
  width: 100% !important;
}
.person-info {
  position: relative;
}
.person-del {
  position: absolute;
  top: -16px;
  right: 0;
  height: 30px;
  cursor: pointer;
}
</style>
